/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

// Messages
import messages from './messages/NotFound_messages';

// Styles
import './styles/NotFound.scss';

// Types
const NOT_FOUND_TYPE_PAGE = 'page';
const NOT_FOUND_TYPE_COMPANY = 'company';

const propTypes = {
  // TODO: Enum? too busy now to check docs
  type: PropTypes.string,
  locale: PropTypes.object,
};

const NotFound = ({ type, locale: { lang } }) => {
  const companySearchLinkLabels = {
    'fi': 'tästä',
    'sv': 'här',
    'en': 'here',
  }
  const companySearchLinks = {
    'fi': 'https://zeckit.com/fi/haku/',
    'sv': 'https://zeckit.com/sv/sok-foretag/',
    'en': 'https://zeckit.com/en/search-company/',
  }
  const reportServiceLinkLabels = {
    'fi': 'Raportti-palvelusta',
    'sv': 'Vastuu Groups rapport-tjänst',
    'en': 'Report Service',
  }
  const vastuuGroupLinks = {
    'fi': 'https://vastuugroup.fi/',
    'sv': 'https://www.vastuugroup.fi/sv/',
    'en': 'https://www.vastuugroup.fi/en/',
  }

  const renderContent = () => {
    if (type === NOT_FOUND_TYPE_PAGE) {
      return (
        <React.Fragment>
          <h1>
            <FormattedMessage
              {...messages.typePageTitle}
              info="Sivua ei löytynyt."
            />
          </h1>
          <h2>
            <FormattedMessage
              {...messages.typePageTroubleshoot}
              info="Tarkista, kirjoititko osoitteen oikein."
            />
          </h2>
        </React.Fragment>
      );
    } else if (type === NOT_FOUND_TYPE_COMPANY) {
      return (
        <React.Fragment>
        <h1>
          <FormattedMessage
            {...messages.typeCompanyTitle}
            info="Hakusi ei tuottanut tuloksia."
          />
        </h1>
        <p>
          <FormattedMessage
            {...messages.typeCompanyDescription}
            info="Uudistamme Vastuu Groupin hakupalveluita."
          />
        </p>
        <p>
          <FormattedMessage
            {...messages.typeCompanyTroubleshoot}
            values={{
              searchLinkHere: (
                <a href={companySearchLinks[lang]}>
                  {companySearchLinkLabels[lang]}
                </a>
              ),
              reportServiceLink: (
                <a href="https://bol.vastuugroup.fi/#/search">
                  {reportServiceLinkLabels[lang]}
                </a>
              ),
              vastuuGroupLink: (
                <a href={vastuuGroupLinks[lang]}>
                  Vastuu Group
                </a>
              ),
            }}
            info={
              <a href="https://zeckit.com/fi/haku">
                Palaa yrityshakuun.
              </a>
            }
          />
        </p>
        </React.Fragment>
      );
    }
    // TODO some generic content not found, should not be needed thou
    return null;
  }

  return (
    <div styleName="NotFound">
      <div className="main pure-g">
        <div className="pure-u-1-24" />
        <div className="pure-u-22-24">
          <div className="container text-center">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

NotFound.propTypes = propTypes;
NotFound.defaultProps = {
  type: NOT_FOUND_TYPE_PAGE,
  locale: { lang: 'fi' },
};

export default NotFound;
export const notFoundTypes = {
  'page': NOT_FOUND_TYPE_PAGE,
  'company': NOT_FOUND_TYPE_COMPANY,
};
